import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, Observable, take } from "rxjs";
import { UserPreferencesService } from "../../services/user-preferences.service";
import { managePageUserPreferenceStrings } from "../../constants/user-preferences.constants";
import { ManageTableViewConfig } from "../../types/manage-ceg-page.types";
import ManageCegTableContainerStore from "../../components/manage-ceg-table-container/manage-ceg-table-container.store";

export interface TableConfigApiPayload {
  columns_to_show: number[];
  misc: {
    columns_to_show: {
      columnsFormula: boolean;
      separate: boolean;
      committedAndPlanned: boolean;
    };
    columnsFormula: boolean;
    segmentBreakdownData: {
      campaignsAndPrograms: boolean;
      unallocated: boolean;
      formula: boolean;
    };
  };
}

@Injectable()
export class TableConfigDialogService {
  private userPreferencesService = inject(UserPreferencesService);
  private _userTableViewConfigPreference$ = new BehaviorSubject<any>(null);
  public userTableViewConfigPreference$ = this._userTableViewConfigPreference$.asObservable();
  constructor() {}

  public postUserTableConfig(companyId, budgetId, personalization_data): Observable<any> {
    return new Observable((observer) => {
      const budgetTableAreaDetails = managePageUserPreferenceStrings['budget_table'];
      const requestPersonalizationData = this.shortenTableConfigData(personalization_data);
      this.userPreferencesService.postUserPersonalizationDataConfig(
        companyId,
        budgetId,
        budgetTableAreaDetails.name,
        budgetTableAreaDetails.personalization_keys.table_config,
        requestPersonalizationData
      ).pipe(take(1))
      .subscribe({
        next: (data) => {
          this.userTableViewConfig = personalization_data;
          observer.next(data);
          observer.complete();
        },
        error: error => {
          observer.error(error);
        }
      });
    });
  }

  public set userTableViewConfig(config: ManageTableViewConfig) {
    this._userTableViewConfigPreference$.next(config);
  }

  public get userTableViewConfig(): ManageTableViewConfig {
    return this._userTableViewConfigPreference$.getValue();
  }

  private getColumnIdFromProperty(property): number {
    const map = ManageCegTableContainerStore.dbId2TableColumnNameMap;
    return map[property];
  }

  private shortenTableConfigData(data) {
    const payload: TableConfigApiPayload = {
      columns_to_show: [],
      misc: {
        columns_to_show: {
          columnsFormula: data.columns.columnsFormula,
          separate: data.columns.separate,
          committedAndPlanned: data.columns.committedAndPlanned
        },
        columnsFormula: data.columnsFormula,
        segmentBreakdownData: data.segmentBreakdownData
      }
    }
    Object.keys(data.columns).forEach((key) => {
      if (
        data.columns[key] &&
        !["columnsFormula","separate","committedAndPlanned"].includes(key)
      ) {
        payload.columns_to_show.push(this.getColumnIdFromProperty(key));
      }
    });
    return payload;
  }
}
